import React from 'react';
import { Box, Typography } from '@mui/material';
import { PAGE_PADDING } from '../../utils/responsive';

// Shared look for the redesigned detail pages (Bus View, Driver/Conductor View).
export const cardStyle = { borderRadius: '12px', border: '1px solid #E5EAF2', boxShadow: '0 1px 3px rgba(16,42,67,.06)', height: '100%', minWidth: 0 };
export const contentStyle = { p: 1.5, '&:last-child': { pb: 1.5 } };
export const fieldGrid = { columnSpacing: 2, rowSpacing: 1 };
export const backButtonStyle = {
  fontWeight: 500, fontSize: 13, lineHeight: 1.2, bgcolor: '#EFF6FF', borderRadius: '8px', px: 1.5, py: .7, minHeight: { xs: 40, sm: 32 }, mb: 1,
  '& .MuiButton-startIcon': { mr: .75 }, '&:hover': { bgcolor: '#DBEAFE' },
};
// mt cancels Layout's top padding so the page starts ~10px from the top; on phones the
// negative mx lets the page background reach the screen edges instead of nesting two paddings.
export const pageStyle = {
  bgcolor: '#F4F7FB', color: '#102A43', minHeight: '100vh', minWidth: 0,
  p: { xs: 1.25, md: 2 }, pt: '10px', mt: { xs: -PAGE_PADDING.xs, sm: -PAGE_PADDING.sm, md: -PAGE_PADDING.md },
  mx: { xs: -PAGE_PADDING.xs, sm: 0 }, borderRadius: { xs: 0, sm: 3 },
  '& .MuiButton-root': { textTransform: 'none', color: '#2563EB' },
};

export function InfoField({ label, value, empty = 'Not updated' }) {
  return <Box sx={{ minWidth: 0 }}><Typography variant="caption" color="text.secondary" display="block" lineHeight={1.3}>{label}</Typography><Typography variant="body2" fontWeight={600} lineHeight={1.35} sx={{ mt: '2px', overflowWrap: 'anywhere', color: '#102A43' }}>{typeof value === 'string' || typeof value === 'number' ? (value === '' ? empty : value) : empty}</Typography></Box>;
}
